import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

const categoryIcons: Record<string, string> = {
  all: 'ri-apps-line',
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
  action: 'ri-fire-line',
  drama: 'ri-emotion-line',
  comedy: 'ri-emotion-happy-line',
  thriller: 'ri-ghost-line',
  daily: 'ri-sun-line',
  bl: 'ri-user-heart-line',
};

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的漫画</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-book-line'} text-lg`}></i>
              </div>
              <div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-0.5">韩漫{cat.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}